import React, { useEffect, useState } from "react";
import Arrivals from "./Arrivals";
import MenuBar from "./MenuBar";
import PropTypes from "prop-types";
import { GetHotels, GetUserParams } from "../../api/services/organization";
import WizardWrapper from "./WizardWrapper";

export default function ReceptionAnywhere({ HotelId = window.user?.CurrentHotel?.Id }) {
    const [selectedReservationForCheckIn, setSelectedReservationForCheckIn] = useState();
    const [user, setUser] = useState({});
    const [currentHotel, setCurrentHotel] = useState({});

    useEffect(() => {
        (async () => {
            let userparams = await GetUserParams();
            const hotels = await GetHotels({ HotelChainID: userparams.Hotel.HotelChainId, IsActive: true, IncludeParameters: true, IncludeOnlyHotelsWithUserPermissions: true })
            const fetchedCurrentHotel = hotels.find(hotel => hotel.Id == userparams.Hotel.Id);
            setUser(userparams.User);
            setCurrentHotel(fetchedCurrentHotel);
        })();
    }, [])

    return (
        <>
            <MenuBar
                user={user}
                onReturnToArrivals={() => setSelectedReservationForCheckIn()}
                hasSelectedReservation={Boolean(selectedReservationForCheckIn)}
            />
            {selectedReservationForCheckIn ? (
                <WizardWrapper reservationDetails={selectedReservationForCheckIn} />
            ) : (
                <Arrivals HotelId={currentHotel.Id || HotelId} onSelectReservation={setSelectedReservationForCheckIn} />
            )}
        </>
    );
}

ReceptionAnywhere.propTypes = {
    HotelId: PropTypes.number,
};
